import React from "react";
import { Phone, MessageCircle } from "lucide-react";
import { CONTACTS } from "@/data/content";

export default function FloatingActions() {
  return (
    <div
      className="fixed bottom-5 right-5 z-50 flex flex-col gap-3"
      data-testid="floating-actions"
    >
      <a
        href={`https://wa.me/${CONTACTS.whatsapp}?text=${encodeURIComponent(CONTACTS.whatsappMsg)}`}
        target="_blank"
        rel="noreferrer"
        aria-label="Contattaci su WhatsApp"
        className="w-14 h-14 rounded-full flex items-center justify-center text-white shadow-lg pulse-ring"
        style={{ backgroundColor: "var(--whatsapp)" }}
        data-testid="fab-whatsapp"
      >
        <MessageCircle size={26} />
      </a>
      <a
        href={`tel:${CONTACTS.phoneRaw}`}
        aria-label="Chiama Davide"
        className="w-14 h-14 rounded-full flex items-center justify-center text-white shadow-lg"
        style={{ backgroundColor: "var(--brand)" }}
        data-testid="fab-call"
      >
        <Phone size={24} />
      </a>
    </div>
  );
}
